import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatSelectModule} from '@angular/material/select';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {
    MatAutocompleteModule,
    MatCardModule,
    MatFormFieldModule,
    MatGridListModule,
    MatInputModule
} from '@angular/material';
import {NotaCreditoComponent} from './notaCredito/nota-credito.component';
import {LoadingModule} from '../../../autenticacion/loadingScreen/loading.module';
import {NgStringPipesModule} from '../../../../pipes/string';
import {MomentModule} from 'angular2-moment';
import {EmisorFacturasComponent} from './emisorFacturas/emisor-facturas.component';
import {NotaDebitoComponent} from './notaDebito/nota-debito.component';
import {ConsumerService} from '../../recursos/servicio/consumer.service';
import {BsDatepickerModule} from 'ngx-bootstrap';
import {CurrencyMaskModule} from 'ng2-currency-mask';
import {MaterialModule} from '../../../material.module';
import {FacturaComponent, FocusDirectiveFactura} from './factura/factura.component';
import {EmisorModule} from '../seguridad/emisor/emisor.module';
import {BajaDocumentoComponent} from './bajaDocumento/baja-documento.component';
import {BoletaComponent, FocusDirectiveBoleta} from './boleta/boleta.component';
import {PreviewComponent} from './preview/preview.component';
import {PreviewNotaComponent} from './previewNota/previewNota.component';
import {HelperFacturadorComponent} from './helper/helperFacturador.component';
import {FocusDirectiveRetencion, RetencionComponent} from './retencion/retencion.component';
import {PreviewRetencionComponent} from './previewRetencion/previewRetencion.component';
import {PrintTicketComponent} from './boleta/componentes/ticket/print.ticket.component';
import {QRCodeModule} from 'angularx-qrcode';
import {SummaryComponent} from './summary/summary.component';
import {GuiaRemisionComponent} from './guia-remision/guia-remision.component';
import {PreviewGuiaRemisionComponent} from './previewGuiaRemision/previewGuiaRemision.component';
import {
    FocusDirectiveGuiaRemision,
    FormatDocumentoGuiaRemision,
    FormatLicenciaGuiaRemision,
    FormatPlacaGuiaRemision
} from "./guia-remision/guia-remision.directive";
import {FocusDirectiveNotaDebitoVacia, NotaDebitoVaciaComponent} from "./notaDebitoVacia/notaDebitoVacia.component";

@NgModule({
    declarations: [NotaCreditoComponent, NotaDebitoComponent, EmisorFacturasComponent, FacturaComponent, BoletaComponent, GuiaRemisionComponent, FocusDirectiveGuiaRemision, FocusDirectiveFactura, FocusDirectiveBoleta, FocusDirectiveRetencion, BajaDocumentoComponent, PreviewComponent, PreviewRetencionComponent, PreviewNotaComponent, HelperFacturadorComponent, RetencionComponent,
        NotaDebitoVaciaComponent, FocusDirectiveNotaDebitoVacia, PrintTicketComponent, SummaryComponent, PreviewGuiaRemisionComponent, FormatPlacaGuiaRemision, FormatLicenciaGuiaRemision, FocusDirectiveGuiaRemision, FormatDocumentoGuiaRemision],
    imports: [CommonModule,
        MatFormFieldModule,
        FormsModule,
        ReactiveFormsModule,
        MatSelectModule,
        ReactiveFormsModule,
        LoadingModule,
        MomentModule,
        MatCardModule,
        BsDatepickerModule.forRoot(),
        NgStringPipesModule,
        MatInputModule,
        MatGridListModule,
        MatAutocompleteModule,
        CurrencyMaskModule,
        MaterialModule,
        EmisorModule,
        QRCodeModule],
    exports: [NotaCreditoComponent, FocusDirectiveNotaDebitoVacia, NotaDebitoVaciaComponent, NotaDebitoComponent, EmisorFacturasComponent, FacturaComponent, BoletaComponent, BoletaComponent, BajaDocumentoComponent, PreviewComponent, PreviewRetencionComponent, PreviewNotaComponent, HelperFacturadorComponent, RetencionComponent, PrintTicketComponent, SummaryComponent, GuiaRemisionComponent, FocusDirectiveGuiaRemision, PreviewGuiaRemisionComponent],
    providers: [ConsumerService],
})

export class EmisorFacturasModule {
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/emisorFacturas/emisor-facturas.module.ts